export default {"src":"/_next/static/image/public/images/ic_info_loyal.f905a8c2526920d6367af8cb6c66b21d.svg","height":20,"width":20};